import { jsx as o } from "react/jsx-runtime";
const n = ({ className: r, width: l = "16", height: t = "16" }) => /* @__PURE__ */ o(
  "svg",
  {
    className: r,
    width: l,
    height: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M15.7657 2.35951C15.4533 2.04707 14.9468 2.04707 14.6343 2.35951L5.04983 11.9441L1.3657 8.25998C1.0533 7.94754 0.546797 7.94757 0.234328 8.25998C-0.0781094 8.57239 -0.0781094 9.07889 0.234328 9.39132L4.48414 13.6411C4.79645 13.9535 5.30333 13.9533 5.61552 13.6411L15.7657 3.49089C16.0781 3.17848 16.0781 2.67195 15.7657 2.35951Z",
        fill: "currentColor"
      }
    )
  }
);
export {
  n as default
};
